import { Route, Navigate } from 'react-router-dom';
import { configure, home } from 'routes/config';

import Configure from 'containers/Business/Agent/Configure';
import Identity from 'containers/Business/Agent/Configure/Identity';
import Knowledge from 'containers/Business/Agent/Configure/Knowledge';
import KnowledgeBaseForm from 'containers/Business/Setting/KnowledgeBase/components/KnowledgeBaseForm';
import KnowledgeDataSetForm from 'containers/Business/Setting/DataSet/Components/DataSetForm';
import KnowledgeForm from 'containers/Business/Agent/Configure/Knowledge/components/KnowledgeForm';
import QaChunkForm from 'containers/Business/Agent/Configure/QaChunk/Components/QaChunkForm';
import Actions from 'containers/Business/Agent/Configure/Actions';
import ActionForm from 'containers/Business/Agent/Configure/Actions/Components/ActionForm';
import DeployPhone from 'containers/Business/Agent/Configure/DeployPhone';
import DeployWeb from 'containers/Business/Agent/Configure/DeployWeb';
import PersonalizedLink from 'containers/Business/Agent/Configure/PersonalizedLink';
import WebUrlForm from 'containers/Business/Agent/Configure/Knowledge/components/WebUrlForm';
import AgentDataSetForm from 'containers/Business/Agent/Configure/Knowledge/components/AgentDataSetForm';
import WebUrlSettingForm from 'containers/Business/Setting/DataSet/Components/WebUrlForm';
import ActionAddColumnForm from 'containers/Business/Agent/Configure/Actions/Components/ActionAddColumnForm';

export const configureRoutes = (
  <Route path={home.configure} element={<Configure />}>
    <Route index element={<Navigate to={configure.identity} replace />} />
    <Route path={configure.identity} element={<Identity />} />
    <Route path={configure.knowledge} element={<Knowledge />}>
      <Route path='add' element={<KnowledgeBaseForm />} />
      <Route path='add-website' element={<WebUrlForm />} />
      <Route path='add-document' element={<AgentDataSetForm />} />
      <Route path=':datasetId/edit-website' element={<WebUrlForm />} />
      <Route path=':datasetId/edit-document' element={<AgentDataSetForm />} />
      <Route path=':knowledgeBaseId/edit' element={<KnowledgeBaseForm />} />
      <Route path=':knowledgeBaseId/dataset' element={<KnowledgeForm />} />
      <Route path=':knowledgeBaseId/dataset/add' element={<KnowledgeDataSetForm />} />
      <Route path=':knowledgeBaseId/dataset/add-website' element={<WebUrlForm />} />
      <Route path=':knowledgeBaseId/dataset/:datasetId/edit' element={<KnowledgeDataSetForm />} />
      <Route path=':knowledgeBaseId/dataset/:datasetId/edit-website' element={<WebUrlSettingForm />} />
      <Route path='qa-chunk/add' element={<QaChunkForm />} />
      <Route path='qa-chunk/:chunkId/edit' element={<QaChunkForm />} />
    </Route>
    <Route path={configure.action} element={<Actions />}>
      <Route path='add' element={<ActionForm />}>
        <Route path='add-column' element={<ActionAddColumnForm />} />
      </Route>
      <Route path=':actionId' element={<ActionForm />} />
    </Route>
    <Route path={configure.deployPhone} element={<DeployPhone />} />
    <Route path={configure.deployWeb} element={<DeployWeb />} />
    <Route path={configure.personalizeLink} element={<PersonalizedLink />} />
  </Route>
);
